import { Card, CardContent, Tab, Tabs } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate, useParams } from 'react-router-dom'
import { useUserStore } from '../../stores/useUserStore'
import { Forbidden } from '../Forbidden'
import styles from './Quotas.module.scss'
import { YoutubeQuotas } from './YoutubeQuotas'

type TabOption = 'youtube'

export const Quotas = (): JSX.Element => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const userStore = useUserStore()
  const params = useParams()

  const [tab, setTab] = useState<TabOption>((params.quotasTab as TabOption) ?? 'youtube')

  useEffect(() => {
    navigate(`/quotas/${tab}`)
  }, [navigate, tab])

  const onTabChange = useCallback(
    (tabValue: TabOption) => {
      setTab(tabValue)
      navigate(`/quotas/${tabValue}`)
    },
    [navigate],
  )

  if (!userStore.isAuthorised('youtubeQuotas.read')) {
    return <Forbidden permission="youtubeQuotas.read" />
  }

  return (
    <Card>
      <CardContent className={styles.container}>
        <Tabs value={tab} onChange={(_, v) => onTabChange(v)}>
          <Tab value="youtube" label={translate('pages.quotas.youtube')} />
        </Tabs>
        {tab === 'youtube' && <YoutubeQuotas />}
      </CardContent>
    </Card>
  )
}
